import React from 'react';
import './CommitteesPage.scss'; // Importing SCSS styles
import AOS from 'aos';
import 'aos/dist/aos.css'; // AOS CSS
import Header from '../../components/ActivePath/Header';

const CommitteesPage: React.FC = () => {
  React.useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  const committees = [
    {
      name: "Grievance Committee",
      members: [
        { name: "Sri Shashidar Y R", designation: "Lecturer EC dept", position: "Chairman", phone: "9008214404" },
        { name: "Sri Kumar R", designation: "Principal EC dept", position: "Member Secretary", phone: "9036447506" },
        { name: "Sri Raju K", designation: "Lecturer Science dept", position: "Member", phone: "9449414830" },
        { name: "Sri Kuberachari S H", designation: "Lecturer EC dept", position: "Member", phone: "7406495888" },
        { name: "Smt Shilpa L", designation: "Lecturer EC dept", position: "Member", phone: "9972283180" },
      ],
    },
    {
      name: "Anti Ragging Committee",
      members: [
        { name: "Sri Kuberachari S H", designation: "Lecturer EC dept", position: "Chairman", phone: "7406495888" },
        { name: "Sri Kumar R", designation: "Principal EC dept", position: "Member Secretary", phone: "9036447506" },
        { name: "Sri Shashidar Y R", designation: "Lecturer EC dept", position: "Member", phone: "9008214404" },
        { name: "Smt Shilpa L", designation: "Lecturer EC dept", position: "Member", phone: "9972283150" },
        { name: "Smt Yashasivini S D", designation: "Lecturer EC dept", position: "Member", phone: "9620284824" },
      ],
    },
    {
      name: "Internal Complaint Committee (ICC)",
      members: [
        { name: "Smt Shilpa L", designation: "Lecturer EC dept", position: "Chairman", phone: "9972283180" },
        { name: "Sri Raju K", designation: "Lecturer Science dept", position: "Member Secretary", phone: "9449414530" },
        { name: "Sri Rajesh K", designation: "Lecturer EC dept", position: "Member", phone: "7406779555" },
        { name: "Sri Shashidar Y R", designation: "Lecturer EC dept", position: "Member", phone: "9008214404" },
        { name: "Smt Sheela HG", designation: "FDA", position: "Member", phone: "9632110493" },
        { name: "Sri Krishnamurthy D H", designation: "Lab Assistant", position: "Member", phone: "9113937190" },
        { name: "Sri Ajay M", designation: "Student", position: "Member", phone: "9900843567" },
        { name: "Kum Vashnavi L", designation: "Student", position: "Member", phone: "8722721145" },
        { name: "Kum Kavana H K", designation: "Student", position: "Member", phone: "9380554745" },
      ],
    },
    {
      name: "SC/ST Committee",
      members: [
        { name: "Smt Yashaswini S D", designation: "Lecturer EC dept", position: "Chairman", phone: "9620284824" },
        { name: "Sri Kumar R", designation: "Principal EC dept", position: "Member Secretary", phone: "5036447506" },
        { name: "Sri Rajesh K", designation: "Lecturer Science dept", position: "Member", phone: "7406779555" },
        { name: "Sri Krishnamurthy D H", designation: "Lab Assistant", position: "Member", phone: "9113937190" },
        { name: "Smt Shilpa L", designation: "Lecturer EC dept", position: "Member", phone: "9972283180" },
      ],
    },
    {
      name: "Industry Cell Committee",
      members: [
        { name: "Sri Shashidhar Y R", designation: "Lecturer EC dept", position: "Chairman", phone: "9008214404" },
        { name: "Sri Kumar R", designation: "Principal EC dept", position: "Member Secretary", phone: "9036447506" },
        { name: "Sri Kuberachari S H", designation: "Lecturer EC dept", position: "Member", phone: "7406495888" },
        { name: "Smt Shilpa L", designation: "Lecturer EC dept", position: "Member", phone: "9972283180" },
        { name: "Sri Dattatreya", designation: "Unique Technologies Jubil", position: "Member", phone: "9448267545" },
        { name: "Sri Nandan M G", designation: "SRS Computer World Kadur", position: "Member", phone: "8722250654" },
      ],
    },
    {
      name: "Student Counsellor Committee",
      members: [
        { name: "Sri Kuberachari S H", designation: "Lecturer EC dept", position: "President", phone: "7406495888" },
        { name: "Sri Kumar R", designation: "Principal EC dept", position: "Member Secretary", phone: "9036447506" },
        { name: "Smt Shilpa L", designation: "Lecturer EC dept", position: "Member", phone: "9972283180" },
      ],
    },
  ];

  return (
    <div className="committees-page">
        <Header pageTitle="" breadcrumb="Committees" />
      <h2 className="page-title" data-aos="fade-up">Committees</h2>
      {committees.map((committee, index) => (
        <section key={index} className="committee-section" data-aos="fade-up">
          <h3 className="committee-name">{committee.name}</h3>
          <table className="committee-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Designation</th>
                <th>Position</th>
                <th>Phone No</th>
              </tr>
            </thead>
            <tbody>
              {committee.members.map((member, idx) => (
                <tr key={idx}>
                  <td>{member.name}</td>
                  <td>{member.designation}</td>
                  <td>{member.position}</td>
                  <td>{member.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ))}
    </div>
  );
};

export default CommitteesPage;
